import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Dialog, Typography } from '@mui/material';
import { PrimaryButon } from '../../../../../components/common/button/PrimaryButon';
import { palette } from '../../../../../../theme/palette';
import { useNavigate } from 'react-router-dom';
const theme = palette('light');
export const DiclinedInfoDialog = ({ open, handleClose }) => {
    const navigate = useNavigate();
    const handleCloseAndNavigate = () => {
        handleClose();
        navigate('/users');
    };
    const handleBackdropClick = (event) => {
        event.stopPropagation();
    };
    return (_jsx(Dialog, { open: open, onClose: (event, reason) => {
            if (reason === 'backdropClick') {
                return;
            }
            handleClose();
        }, maxWidth: false, BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            },
            onClick: handleBackdropClick
        }, disableEscapeKeyDown: true, children: _jsxs(Box, { width: { xs: 330, sm: 600, md: 717 }, sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                height: '295px',
                px: 5
            }, children: [_jsx(Typography, { variant: 'h3', color: 'initial', mt: 2, children: "User declined" }), _jsx(Typography, { variant: 'subtitle1', color: theme.black.dark, children: "The user has been informed of the reason for the decline." }), _jsx(Box, { width: { xs: '100%', sm: '386px' }, mt: 5, children: _jsx(PrimaryButon, { onClick: handleCloseAndNavigate, children: "Close" }) })] }) }));
};
